import { render, staticRenderFns } from "./Seed.vue?vue&type=template&id=81b43cc8&"
import script from "./Seed.vue?vue&type=script&lang=ts&"
export * from "./Seed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports